import { CaretDown } from 'phosphor-react';
import { forwardRef, useState, ComponentPropsWithoutRef, CSSProperties, ElementRef } from 'react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '../../../../components/Collapsible';
import { cn } from '../../../../utils/classnames';
import styles from './SideToolbarCollapsible.module.css';

export interface SideToolbarCollapsibleProps extends ComponentPropsWithoutRef<typeof Collapsible> {
  titleText: string;
  triggerClassName?: string;
  triggerStyle?: CSSProperties;
  contentClassName?: string;
  contentStyle?: CSSProperties;
}

export const SideToolbarCollapsible = forwardRef<
  ElementRef<typeof Collapsible>,
  SideToolbarCollapsibleProps
>(
  (
    {
      children,
      className,
      triggerClassName,
      triggerStyle,
      contentClassName,
      contentStyle,
      titleText,
      ...rest
    },
    ref
  ) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <Collapsible
        ref={ref}
        open={isOpen}
        onOpenChange={setIsOpen}
        className={cn('space-y-2 mt-3', className)}
        {...rest}
      >
        <div className="flex items-center justify-between space-x-4 px-[18px]">
          <div className={styles.collapseLabel}>{titleText}</div>
          <CollapsibleTrigger asChild>
            <button
              type="button"
              className={cn(styles.collapseTrigger, triggerClassName)}
              style={triggerStyle}
            >
              <CaretDown className={cn('h-4 w-4', isOpen && 'rotate-180')} aria-hidden />
              <span className="sr-only">Toggle</span>
            </button>
          </CollapsibleTrigger>
        </div>
        <CollapsibleContent
          className={contentClassName}
          style={contentStyle}
          forceMount
          hidden={!isOpen}
        >
          {children}
        </CollapsibleContent>
      </Collapsible>
    );
  }
);

SideToolbarCollapsible.displayName = 'SideToolbarCollapsible';
